import {
    BATTERY,
    BATTERY_DISPLAY_NAME,
    EVAC_DISPLAY_NAME,
    EVCP_AC,
    EVCP_DC,
    EVDC_DISPLAY_NAME,
    EV_V2G,
    HEAT_PUMP,
    HP_DISPLAY_NAME,
    SOLAR_PV,
    SOLAR_PV_DISPLAY_NAME,
    V2G_INVERTER_DISPLAY_NAME,
} from "../../constants/generalConstants"

export const LCT_DISPLAY_NAME_DISPATCHER = {
    [SOLAR_PV]: SOLAR_PV_DISPLAY_NAME,
    [EVCP_AC]: EVAC_DISPLAY_NAME,
    [EVCP_DC]: EVDC_DISPLAY_NAME,
    [EV_V2G]: V2G_INVERTER_DISPLAY_NAME,
    [HEAT_PUMP]: HP_DISPLAY_NAME,
    [BATTERY]: BATTERY_DISPLAY_NAME,
}
// DnoApproved: "DNO Approved",
// DnoApprovedLimit: "DNO Approved Limit",
// AutoApproved: "Auto Approved",
// Resolved state keys are set by reporting lambda
export const RESOLVED_STATUS_DISPATCHER = {
    FurtherInfoRequired: ["Further", "Info", "Required"],
    DnoApproved: ["DNO", "Approved"],
    DnoApprovedLimit: ["DNO", "Approved", "Limit"],
    AutoApproved: ["Auto", "Approved"],
}
